import type { TFunction } from 'i18next'

import { getAnchorsTypesChoices } from '@/entities/anchor'

export const getAnchorSelectOptions = (t: TFunction) =>
	getAnchorsTypesChoices(t).map((item) => ({
		...item,
		description: t(`app.${item.value}_anchor.description`),
	}))
